'use client';
import { VersionVo } from '@/apis/help/help.interface';
import VersionIcon from '@/assets/icons/VersionIcon.svg';
import UKTitleBar from '@/components/UKTitleBar';
import { useTranslation } from '@/i18n/client';
import { uaParse } from '@/intl-jdi-common-ssr/utils/uaParser';
import { useRouter } from 'next/navigation';
import React, { useEffect } from 'react';
import styles from './index.module.scss';

interface DetailProps {
  versionList: VersionVo[];
}

const Detail: React.FC<DetailProps> = ({ versionList }) => {
  const route = useRouter();
  const isInJoybuyApp = uaParse().isInJoybuyApp;
  const { t } = useTranslation();

  useEffect(() => {
    if (isInJoybuyApp) {
      handleSetPageTitle();
    }
  }, []);

  const handleSetPageTitle = async () => {
    const bridgeModule = await import('@/utils/bridge');
    const JSBridge = bridgeModule.JSBridge;
    JSBridge.functionInApp({
      method: 'setPageNavigation',
      payload: {
        title: t('privacyPolicy.archivedTitle'),
      },
    });
  };

  const handleBack = () => {
    route.back();
  };

  const handleToPrivacy = (item: VersionVo) => {
    route.push(`/privacy-policy/archive/${item.id}`);
  };

  return (
    <div className={styles.detailWrapper} id='white_screen_detection_element'>
      {!isInJoybuyApp && (
        <UKTitleBar title={t('privacyPolicy.archivedTitle')} toBack={handleBack} />
      )}
      <div className={styles.mainWrapper} style={{ marginTop: !isInJoybuyApp ? 44.67 : 0 }}>
        <div className={styles.description}>{t('privacyPolicy.archivedDescription')}</div>
        <div className={styles.versionWrapper}>
          {versionList.map((item) => (
            <div key={item.id} className={styles.versionItem} onClick={() => handleToPrivacy(item)}>
              <VersionIcon />
              <a target='_self'>{item.version}</a>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Detail;
